const HUBSPOT_FORM_ID_MATCHER = /^hsForm/;

const hasHubspotFormId = (element: HTMLFormElement) =>
  Boolean(element.id.match(HUBSPOT_FORM_ID_MATCHER));

const isHubspotForm = (element: unknown): boolean =>
  element instanceof HTMLFormElement && hasHubspotFormId(element);

export default isHubspotForm;
